// Иконка lucide по правилам «Табеля»: контур, size-icon (16 px), линия 1.75. Других размеров
// иконок в дизайн-системе нет (README «Иконки», Constitution X), поэтому размер и толщину линии
// не переопределить: ни типами, ни свойствами в обход типов.
import type { LucideIcon, LucideProps } from 'lucide-react';
import { cx } from './cx.ts';

export type { LucideIcon };

export const ICON_SIZE = 16;
export const ICON_STROKE = 1.75;

export interface IconProps extends Omit<
  LucideProps,
  'ref' | 'size' | 'strokeWidth' | 'absoluteStrokeWidth' | 'width' | 'height'
> {
  icon: LucideIcon;
  /** Подпись для программ чтения экрана; без неё иконка декоративная. */
  label?: string;
}

export function Icon({ icon: Glyph, label, className, ...rest }: IconProps) {
  return (
    <Glyph
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
      {...rest}
      size={ICON_SIZE}
      width={ICON_SIZE}
      height={ICON_SIZE}
      strokeWidth={ICON_STROKE}
      absoluteStrokeWidth={false}
      className={cx('kp-ico', className)}
    />
  );
}
